import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { demoPurchaseUrl } from './demo.constants';
import { DemoService } from './demo.service';

@Component({
  selector: 'app-demo',
  templateUrl: './demo.component.html',
  styleUrls: ['./demo.component.scss']
})
export class DemoComponent implements OnInit {
  isSpinner = false;
  loadError = false;

  constructor(
    private demoService: DemoService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.applyQueryLanguage();
  }

  get hasSession(): boolean {
    return this.demoService.hasSession();
  }

  get isCompleted(): boolean {
    return this.demoService.isCompleted();
  }

  get purchaseUrl(): string {
    return demoPurchaseUrl(localStorage.getItem('language'));
  }

  async startDemo(): Promise<void> {
    this.applyQueryLanguage();
    if (this.demoService.isCompleted()) {
      this.router.navigate(['/demo/complete'], { queryParamsHandling: 'preserve' });
      return;
    }
    this.isSpinner = true;
    this.loadError = false;
    try {
      await this.demoService.startSession();
      this.router.navigate(['/demo/question', 1], { queryParamsHandling: 'preserve' });
    } catch (err) {
      this.loadError = true;
    }
    this.isSpinner = false;
  }

  continueDemo(): void {
    if (this.demoService.isCompleted()) {
      this.router.navigate(['/demo/complete'], { queryParamsHandling: 'preserve' });
      return;
    }
    this.router.navigate(['/demo/question', this.demoService.getCurrentIndex()], { queryParamsHandling: 'preserve' });
  }

  goToResults(): void {
    this.router.navigate(['/demo/complete'], { queryParamsHandling: 'preserve' });
  }

  private applyQueryLanguage(): void {
    this.demoService.applyQueryLanguage(
      this.route.snapshot.queryParamMap.get('lang'),
      this.route.snapshot.queryParamMap.get('language')
    );
  }
}
